module.exports = __webpack_public_path__ + "static/media/carousel7.a40fcc40.jpeg";